/** Mirrors PacketRecoveryEventSerializer field/method labels. */

const FIELD_LABELS: Record<string, string> = {
	'step.material_accepted': 'Material Accepted',
	'step.order_accepted': 'Order Accepted',
	'step.programming_complete': 'Programming Complete',
	'step.machining_complete': 'Machining Complete',
	'step.icf_operator': 'ICF Operator',
	'step.icf_accepted': 'ICF Accepted',
	'step.traveler_completed': 'Traveler Completed',
	'step.customer_notified': 'Customer Notified',
	outake: 'Production Outake',
	intake: 'PartsBadger Intake',
	'fai.visual': 'Visual inspection',
	'fai.inspectors': 'FAI inspector / date',
	revision: 'Revision',
	material_cert_na: 'Material cert N/A',
	'oli.prior_tasks': 'Prior job tasks',
	'*': 'Packet copy',
};

const METHOD_LABELS: Record<string, string> = {
	ma_match_order_accepted: 'Set Material Accepted date to Order Accepted',
	copy_machining: 'Copied from Machining Completed',
	copy_icf_operator: 'Copied from ICF Operator',
	copy_order_accepted: 'Copied from Order Accepted',
	copy_programming: 'Copied from Programming Complete',
	copy_customer_notified: 'Copied from Customer Notified',
	qty_gap_row: 'Added quantity-gap row',
	qty_gap_row_pb: 'Added PartsBadger Intake quantity-gap row',
	approve: 'Approved and stamped Traveler Completed',
	approve_complete_tasks: 'Marked prior job tasks Completed',
	complete_initials_from_user:
		'Filled Traveler Completed initials from user profile',
	rollback: 'Restored original packet copy',
	return_to_review: 'Returned to review',
	manual: 'Manual edit',
	manual_revision: 'Set revision',
	extract_revision: 'Extracted revision from part number',
	material_cert_na: 'Marked material cert not applicable',
	program_posted_or_bs: 'Filled Programming Complete',
	oa_match_programming: 'Set Order Accepted to Programming Complete',
	icf_match_programming: 'Set ICF Accepted to Programming Complete',
	earliest_action_bs: 'Set Order Accepted from earliest action',
	material_receipt: 'Set Material Accepted from receipt',
	complete_visual_pass: 'Filled blank visual as Pass',
	fai_inspector_fill: 'Filled FAI sample inspector / date',
	keyence_link: 'Linked Keyence report',
	outake_match_intake: 'Aligned Production Outake to Intake',
};

const STATUS_FIELD_LABELS: Record<string, string> = {
	cam_programming_status: 'CAM Programming',
	material_prep_status: 'Material Prep',
	cart_assembly_status: 'Cart Assembly',
	machine_setup_status: 'Machine Setup',
	machining_status: 'Machining',
	quality_status: 'Quality',
};

export const fieldLabel = (key: string) => FIELD_LABELS[key] || key;

export const methodLabel = (method: string) => METHOD_LABELS[method] || method;

export function formatAuditValue(value: unknown): string {
	if (value == null) return '—';
	if (typeof value === 'boolean') return value ? 'Yes' : 'No';
	if (typeof value === 'number') return String(value);
	if (typeof value === 'string') return value;
	if (Array.isArray(value)) {
		if (!value.length) return '—';
		if (value.every((row) => row && typeof row === 'object')) {
			return `${value.length} row${value.length === 1 ? '' : 's'}`;
		}
		return value.map(String).join(', ');
	}
	if (typeof value === 'object') {
		const rec = value as Record<string, unknown>;
		if ('user' in rec || 'at' in rec) {
			const user = (rec.user as string) || '—';
			const at = typeof rec.at === 'string' ? rec.at.split('T', 1)[0] : '—';
			return `${user} · ${at}`;
		}
		const parts = Object.entries(rec).map(([key, item]) => {
			const label = STATUS_FIELD_LABELS[key] || FIELD_LABELS[key] || key;
			return `${label}: ${item}`;
		});
		return parts.join(', ') || '—';
	}
	return String(value);
}
